import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

/** Slug tenant di default per il portale W3 in dev (tenant demo dedicato W3 Suite). */
export const DEFAULT_TENANT_SLUG = 'demow3suite';
